import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import Datetime from 'react-datetime';
import Col from "components/Grid/GridItem.js";
import Grid from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
//import { loadUserFromStorage } from "_services/oauth";
import avatar from "assets/img/faces/marc.jpg";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSCheckBox from "components/Forms/TSCheckBox";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Icon from '@material-ui/core/Icon';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import InfoIcon from '@material-ui/icons/Info';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal, ModalBody 
} from "reactstrap";

import axios from "axios";


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);
const config = {
  clientId: "react.client",
  accessTokenUri: `../api/v1/identity/access_token`,
  userInfoUri: `../api/v1/profile`,
  endsessionUri: `connect/endsession`,
  introspectURL: `connect/introspect`,
  scopes: [],
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}

export default function UserProfile() {

  var moment = require('moment');
  require('moment/locale/th');

  const history = useHistory();

  const classes = useStyles();
  const [Profile, setProfile] = useState([]);
  const [tabValue, setTabValue] = React.useState(0);

  const [UserID, setUserID] = useState("");
  const [TitleName, setTitleName] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [NickName, setNickName] = useState("");
  const [Cid, setCid] = useState("");
  const [BirthDT, setBirthDT] = useState("");

  const [Email, setEmail] = useState("");
  const [Gmail, setGmail] = useState("");
  const [GenderKey, setGenderKey] = useState(0);
  const [TypeGovKey, setTypeGovKey] = useState(0);
  const [PositionName, setPositionName] = useState("");
  
  const [Address, setAddress] = useState("");
  const [Photo, setPhoto] = useState("");
  const [MobilePhone, setMobilePhone] = useState("");
  const [IsActive, setIsActive] = useState(0);
  const [IsShowBirthdate, setIsShowBirthdate] = useState(0);
  const [LineNotify, setLineNotify] = useState("");
  const [LineToken, setLineToken] = useState("");
  const [ArrTypeGov, setArrTypeGov] = useState([]);
  const [UserName, setUserName] = useState('');
  const [dateFocus, setDateFocus] = useState(false);
  const [emp, setEmp] = useState(null);

  const [icon, setIcon] = useState("far fa-question-circle");

  const [modal, setModal] = useState(false);
  const [modalClear, setModalClear] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [UserEducation, setUserEducation] = useState([]);
  
  const genderList = [{ label:"ชาย", value:1}, { label:"หญิง", value:2}];

  const search = window.location.search;
  const params = new URLSearchParams(search);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {



    axios({
      method: 'get',
      url: "/api/v1/typegov"
    })
    .then(
      res => {
          var result = res.data;
          var json = JSON.parse(JSON.stringify(result.data).split('"name":').join('"label":').split('"typeGovKey":').join('"value":'));
          setArrTypeGov(json)
        },
        error => {alert(error);}
    );  


    axios({
      method: 'get',
      url: "/api/v1/profile"
    })
    .then(
      res => {
          var user = res.data
  
          setUserName(user.userName)
          setUserID(user.userID)
          setTitleName(user.titleName)
          setFirstName(user.firstName)
          setLastName(user.lastName)
          setNickName(user.nickName)
          setCid(user.cid)
          setGenderKey(user.genderKey)
          setBirthDT(user.birthDT)
          setMobilePhone(user.mobilePhone)
          setEmail(user.email)
          setGmail(user.gmail)
          setAddress(user.address)
          setTypeGovKey(user.typeGovKey)
          setLineNotify(user.lineNotify)
          setLineToken(user.lineToken)
          setPhoto(user.photo)
          setIsShowBirthdate(user.isShowBirthdate)
          setIsActive(user.isActive)
          setPositionName(user.positionName)

            axios.get("/api/v1/empEducation/" + user.cid)
        .then(
          result => {
              if(result.data.result == 200)
              {
                setUserEducation(result.data.data[0].empEducationOther)
              }
            },
            error => {console.log(error); }
        );  

          if(params.get("code") != null && params.get("state") ==  user.userID)
          {
            setModal(true);
          }
      

        },
        error => {console.log(error);
        }
    );  
  },[]);

  const editUser = () => {

    var usr = { 
     titleName: TitleName,
     firstName: FirstName,
     lastName: LastName,
     nickName: NickName,
     cid: Cid,
     birthDT: BirthDT,
     isShowBirthdate: IsShowBirthdate,
     genderKey: GenderKey,
     typeGovKey: TypeGovKey,
     positionName: PositionName,
     email: Email,
     gmail: Gmail,
     lineNotify: LineNotify,
     lineToken: LineToken,
     photo: Photo,
     address: Address,
     mobilePhone: MobilePhone,
     isActive: IsActive,
    };

  axios.put("/api/v1/profile", usr)
  .then(
    res => {
       
        if(res.data.result == 200)
        {
            alert('บันทึกสำเร็จ')
            setEmp(null)
        }
      },
      error => {console.log(error);
      }
  );  


    };


    const handleLineClear = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

            axios.put('/api/v1/profile/clearlinenotify')
                .then(
                    result => {

                        if (result.data.result == 200) {



                            setIcon("far fa-question-circle");
                            setModalClear(false)
                            setModal2(true)
                        }
                        else {
                            setIcon("far fa-question-circle");
                            setModalClear(false)
                            setErrMsg(result.data.msg)
                            setModalError(true)
                        }

                    },
                    error => { console.log(error); }
                );

        


    };

  const handleLineMerge = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    if(params.get("code") != null && params.get("state") ==  UserID)
    {
      
      axios.put('/api/v1/profile/linenotify/'+params.get("code"))
      .then(
        result => {
          
          if(result.data.result == 200)
          {
   
          
  
            setIcon("far fa-question-circle"); 
            setModal(false) 
            setModal2(true)
          }
          else
          {
            setIcon("far fa-question-circle"); 
            setModal(false) 
            setErrMsg(result.data.msg)
            setModalError(true) 
          }
  
        },
        error => {console.log(error);}
      );  

    }


    };



  const logout = () => {
    //e.preventDefault(); 
    window.location.href='/auth/logout';
  };

  const refresh = () => {
    //e.preventDefault(); 
    window.location.href='/home/profile';
  };

  return (
    <div>
      <Grid>

        <Col xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={(e) => e.preventDefault()}>
                <img src={'https://e.trangskin.go.th/avatar/'+UserName+'.jpg'} style={{width: 130, height: 130, borderRadius: 130/ 2, objectFit: 'cover', objectPosition: '100% 0'}} />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h4 className={classes.cardTitle}>{FirstName} {LastName}</h4>
              <h6 className={classes.cardCategory}>{PositionName}</h6>
              <p className={classes.description}>
                {params.get("code")}
              </p>
              <p>
              
              </p>             
              <Grid >
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  {(LineNotify != null && LineNotify != "") ?
                                      <a href="#" onClick={e => (e.preventDefault(), setModalClear(true))} >
                                          <i className={"fab fa-line"} style={{ fontSize: "4em", color: '#5CBD37' }}></i>
                                      </a>
                                      :
                                      <a href={"https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=O72xTnEklQ9QTBwk6mpfLm&redirect_uri=https://e.trangskin.go.th/home/profile&scope=notify&state=" + UserID}>
                                          <i className={"fab fa-line"} style={{ fontSize: "4em", color: (LineNotify != null && LineNotify != "") ? '#5CBD37' : 'gray' }}></i>
                                      </a>
                                  }
                </Col>
               

                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Button color="danger" onClick={logout} round style={{ fontFamily: '"Sarabun", sans-serif' }}>
                      Logout
                    </Button>
                </Col>

             
              </Grid>             
              

            </CardBody>
          </Card>
        </Col>


        <Col xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Edit Profile</h4>
              <p className={classes.cardCategoryWhite}>Complete your profile</p>
            </CardHeader>
            <CardBody>
              <AppBar position="static" color="default">
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="on"
                  indicatorColor="primary"
                  textColor="primary"
                  aria-label="scrollable force tabs example"
                >
                  <Tab label="ข้อมูลส่วนบุคคล" icon={<InfoIcon />} {...a11yProps(0)} />
                  <Tab label="ประวัติการอบรม/ดูงาน/สัมนา" icon={<PersonPinIcon />} {...a11yProps(1)} />
                </Tabs>
              </AppBar>
              
            <TabPanel value={tabValue} index={0}>       
                       
            <Grid>
           
           <Col xs={12} sm={4} md={3} lg={3} xl={2}>
             <TSText readOnly={true}  label="คำนำหน้า" defaultValue={TitleName} value={TitleName} onChange={e => setTitleName(e.target.value)} />
           </Col>
           <Col xs={12} sm={4} md={3} lg={3} xl={2}>
             <TSText readOnly={true} label="ชื่อ" value={FirstName} onChange={e => setFirstName(e.target.value)} />
           </Col>
           <Col xs={12} sm={4} md={3} lg={3} xl={2}>
             <TSText readOnly={true} label="สกุล" value={LastName} onChange={e => setLastName(e.target.value)} />
           </Col>
           <Col xs={12} sm={4} md={3} lg={3} xl={2}>
             <TSText label="ชื่อเล่น" value={NickName} onChange={e => setNickName(e.target.value)} />
           </Col>
           <Col xs={12} sm={4} md={4}  lg={4} xl={2} >
             <TSText readOnly={true} label="เลขบัตรประจำตัวประชาชน" value={Cid} onChange={e => setCid(e.target.value)} />
           </Col>
           <Col xs={12} sm={4} md={4} lg={4} xl={2}>
             <TSSelect2 fontSize='1em' label="เพศ" options={genderList} value={GenderKey} onChange={e => setGenderKey(e.value) } />
           </Col>
           <Col xs={12} sm={6} md={4} lg={4} xl={3}>
             <Label>วันเดือนปีเกิด</Label>
                <FormGroup
                      style={{ padding: '0 0px', marginBottom: '10px' }}
                      className={
                          "input-lg" + (dateFocus ? " input-group-focus" : "")
                      }
                  >
                      <i className="far fa-calendar-check fa-2x" style={{
                          position: 'absolute',
                          zIndex: 1,
                          color: '#6c757d'
                      }}
                      ></i>
                        <Datetime
                            open={false}
                            value={moment(BirthDT).isValid() ? moment(BirthDT) : null}
                            renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                            inputProps={{
                                name: "BirthDT",
                                placeholder: "วันเดือนปีเกิด",
                                readOnly: true,
                                disabled: true,
                                style: {
                                    fontSize: '1.2em',
                                    borderRadius: 0,
                                    paddingLeft: '50px',
                                    cursor: 'default',
                                    background: '#e9ecef',
                                    color: '#495057'
                                }
                            }}
                            closeOnSelect={true}
                            closeOnTab={true}
                            dateFormat="D MMMM BBBB"
                            timeFormat={false}
                      />

                      
                  </FormGroup>
                  <TSCheckBox checked={IsShowBirthdate} onChange={e => setIsShowBirthdate(!IsShowBirthdate) } /> {(IsShowBirthdate)? <span style={{ color: 'green' }} >แสดงวันเกิด </span>  :<span style={{ color: 'red' }}>ไม่แสดงวันเกิด </span>  }
           </Col>

           <Col xs={12} sm={6} md={4} lg={4} xl={3} >
             <TSText label="โทรศัพท์" value={MobilePhone} onChange={e => setMobilePhone(e.target.value)} />
           </Col>
           <Col xs={12} sm={6} md={4} lg={4} xl={3}>
             <TSText label="Email" value={Email} onChange={e => setEmail(e.target.value)} />
           </Col>
           <Col xs={12} sm={6} md={4} lg={4} xl={3}>
             <TSText label="Gmail" value={Gmail} onChange={e => setGmail(e.target.value)} />
           </Col>
 
           <Col xs={12} sm={12} md={12}>
               <div className="textarea-container" style={{ padding: 0 }}>
                     <Label for="Address">ที่อยู่ </Label>  
                         {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                     <Input
                         id="Address"
                         cols="80"
                         name="Address"
                         placeholder="ที่อยู่"
                         rows="4"
                         type="textarea"
                         className="custom"
                         style={{ fontSize: '1.2em', maxHeight: '150px' }}
                         value={Address}
                         onChange={e => setAddress(e.target.value) }
                         ></Input>
                 </div>
           </Col>
           <Col xs={12} sm={6} md={6} lg={4} xl={4}>
             <TSSelect2 isDisabled={true} fontSize='1em' label="ประเภทเจ้าหน้าที่" options={ArrTypeGov} value={TypeGovKey} onChange={e => setTypeGovKey(e.value) } />
           </Col>
           <Col xs={12} sm={6} md={6} lg={4} xl={4}>
             <TSText readOnly={true}  label="ตำแหน่ง" value={PositionName} onChange={e => setPositionName(e.target.value)} />
           </Col>

           <Col xs={12} sm={12} md={12} lg={4} xl={4}>
             <TSText label="รูป" value={Photo} onChange={e => setPhoto(e.target.value)} />
           </Col>

           <Col xs={12} sm={12} md={12} lg={6} xl={3} hidden>
             <TSText label="LineNotify" value={LineNotify} onChange={e => setLineNotify(e.target.value)} />
           </Col>

           <Col xs={12} sm={12} md={12} lg={6} xl={3} hidden>
             <TSText label="LineBot" value={LineToken} onChange={e => setLineToken(e.target.value)} />
           </Col>

           <Col xs={12} sm={12} md={4} hidden>
              <TSCheckBox checked={IsActive} onChange={e => setIsActive(!IsActive) } />{(IsActive)? <span style={{ color: 'green' }} >เปิดการใช้งานอยู่ </span>  :<span style={{ color: 'red' }}>ปิดการใช้งานไปแล้ว </span>  }
           </Col>      

           <Col xs={12} sm={12} md={12} style={{textAlign:'center'}} >

             <Button
               style={{maxWidth: '400px;'}}
               color="primary"
               type="button"
               onClick={editUser}
               disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
             >
               <h4>บันทึก</h4>
             </Button>

           </Col>
            </Grid>
            </TabPanel>

                 <TabPanel value={tabValue} index={1}>
                                       <Table className={classes.table} aria-label="simple table" >
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>วันที่เริ่มต้น</TableCell>
                                                                <TableCell>วันที่สิ้นสุด</TableCell>
                                                                <TableCell>ชื่อหลักสูตร</TableCell>
                                                                <TableCell>หน่วยงานที่จัด</TableCell>
                                                                <TableCell>สถานที่</TableCell>
                                                                <TableCell>ระยะเวลา</TableCell>
                                                                <TableCell>หมายเหตุ</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {UserEducation.map((row) => (
                                                                <>
                                                                    <TableRow key={1}>
                                                                        <TableCell component="th" scope="row">{row.fromDate ? moment(row.fromDate).format("D MMMM BBBB") : "-"}</TableCell>
                                                                        <TableCell component="th" scope="row">{row.toDate ? moment(row.toDate).format("D MMMM BBBB") : "-"}</TableCell>
                                                                        <TableCell component="th" scope="row">{row.topicName}</TableCell>
                                                                        <TableCell component="th" scope="row">{row.organizationName}</TableCell>
                                                                        <TableCell component="th" scope="row">{row.placeName}</TableCell>
                                                                        <TableCell component="th" scope="row">{row.durationNote}</TableCell>
                                                                        <TableCell component="th" scope="row">{row.note}</TableCell>
                                                                    </TableRow>
                                                                </>
                                                            ))}
                                                            {/* <TableRow key={99}>
                                                                <TableCell component="th" scope="row">
                                                                    <Button
                                                                        style={{ maxWidth: '400px;' }}
                                                                        color="success"
                                                                        type="button"
                                                                        onClick={handleNewEducation(UserName)}
                                                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                                    >
                                                                        <Icon className="fa fa-plus" />
                                                                        <h4>เพิ่ม</h4>
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow> */}
                                                        </TableBody>
                                                    </Table>
                                    </TabPanel>

            </CardBody>
            <CardFooter>
            <Modal toggle={() => setModal(false)} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={icon}
                                  style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center"
                                }}
                              >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                  ? "ยืนยันการเชื่อมโยง Line"
                                  : "กำลังตรวจสอบข้อมูล"}
                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
        
                              <Button
                                color="primary"
                                type="button"
                                onClick={handleLineMerge}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                              >
                                <h4>ยืนยัน</h4>
                              </Button>

                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModal(false)}
                              >
                                <h4>ยกเลิก</h4>
                              </Button>

                            </div>
                          </Modal>

                          <Modal toggle={() => setModalClear(false)} isOpen={modalClear}>
                              <div className="modal-header justify-content-center">
                                  <div>
                                      <i
                                          className={icon}
                                          style={{ color: "blue", fontSize: "2em" }}
                                      ></i>
                                  </div>
                              </div>
                              <ModalBody>
                                  <p
                                      style={{
                                          textAlign: "center"
                                      }}
                                  >
                                      {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                          ? "ยืนยันลบ Line Notify"
                                          : "กำลังตรวจสอบข้อมูล"}
                                  </p>
                                  <p> </p>
                              </ModalBody>
                              <div className="modal-footer">

                                  <Button
                                      color="primary"
                                      type="button"
                                      onClick={handleLineClear}
                                      disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                  >
                                      <h4>ใช่</h4>
                                  </Button>

                                  <Button
                                      color="primary"
                                      type="button"
                                      onClick={() => setModalClear(false)}
                                  >
                                      <h4>ไม่ใช่</h4>
                                  </Button>

                              </div>
                          </Modal>

                          {/* Success */}
                          <Modal toggle={() => refresh()} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={() => refresh()}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>

                             
                            </div>
                          </Modal>           

                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>
            </CardFooter>
          </Card>
        </Col>

      </Grid>
    </div>
  );
}
